// Filetype ESM so that next.config.mjs can access it

const defaultLocale = 'da';
const locales = [defaultLocale, 'en', 'de']; // List of languages that are supported
const localeDetection = false;

const config = { defaultLocale, locales, localeDetection }
export default config